import cn from 'classnames';
import { useState, useEffect } from 'react';

import eventThrottle from '../../util/eventThrottle.js';
import offsetTopDocument from '../../util/offsetTopDocument.js';

export default function SideNavJumpMenu({ menu, menuDepth }) {
  const [activeAnchor, setActiveAnchor] = useState('');

  const jumpOffset = 16;

  const getPageAnchors = () => {
    const anchors = menu.map((item) => {
      const element = document.getElementById(item.anchor);
      if (!element) {
        /* eslint-disable-next-line no-console */
        console.error(`LDS ERROR [Unexpected Failure]: Side nav jump menu anchors must match elements existing in the
        DOM. Check the anchor for a jump menu item with the text "${item.text}"`, '\n>>> in LdsSideNavJumpMenu');
      }
      return {
        anchor: item.anchor,
        element,
      };
    });
    return anchors;
  };

  const setUrlHash = (anchor) => {
    const url = new URL(window.location);
    url.hash = anchor;
    history.pushState({}, '', url);
  };

  const jumpToAnchor = (e, anchor) => {
    e.preventDefault();
    const pageAnchors = getPageAnchors();
    const { element } = pageAnchors.find((item) => item.anchor === anchor);
    if (!element) return;
    window.scrollTo({ top: offsetTopDocument(element) - parseInt(jumpOffset, 10), behavior: 'smooth' });
    setUrlHash(anchor);
    // focus on the anchor after we scroll to it for a11y purposes
    // half a second delay to allow for scrolling to finish
    setTimeout(() => document.getElementById(anchor).focus({ focusVisible: true }), 500);
  };

  function getActiveAnchor() {
    const pageAnchors = getPageAnchors();
    return [...pageAnchors].reverse()
      .reduce((active, item) => {
        if (active !== false || !item.element) return active;
        const offsetTop = offsetTopDocument(item.element)
          - 1
          - parseInt(jumpOffset, 10);
        const windowScroll = document.documentElement.scrollTop || window.pageYOffset;
        return offsetTop < windowScroll ? item : active;
      }, false);
  }

  const onPageScroll = () => {
    const activeAnchor = getActiveAnchor();
    if (!activeAnchor) return;
    setActiveAnchor(activeAnchor.anchor);
    setUrlHash(activeAnchor.anchor);
  };
  const throttledScroll = eventThrottle(onPageScroll, 100);

  useEffect(() => {
    window.addEventListener('scroll', throttledScroll);
    return () => window.removeEventListener('scroll', throttledScroll);
  }, []);

  return (
    <ul
      className={cn(
        'lds-side-nav-jump-menu',
        'lds-side-nav-menu',
        `depth-${menuDepth}`
      )}
    >
      {
        menu.map((menuItem, idx) => (
          <li
            key={idx}
            className={cn(
              'lds-side-nav-menu-item',
              'lds-side-nav-jump-menu-item',
              {
                active: menuItem.anchor === activeAnchor,
              }
            )}
          >
            <a
              href={menuItem.anchor}
              className="lds-side-nav-menu-item-content"
              onClick={(e) => jumpToAnchor(e, menuItem.anchor)}
            >
              <span className="lds-side-nav-jump-menu-item-content-container">
                {
                  menuItem.slot
                  && <>{menuItem.slot}</>
                }
                {
                  !menuItem.slot
                  && <>{menuItem.text}</>
                }
              </span>
            </a>
          </li>
        ))
      }
    </ul>
  );
}
